import { orgCompositionInternalStatusUrl } from '../urls';
import refresh from '../refresh';

export async function patchRevertCompositionExportedStatus(orgId, compId, type) {
  const data = {
    org: orgId,
    comp: compId,
    type,
  };
  return refresh(async () => {
    const response = await fetch(orgCompositionInternalStatusUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}

export async function putOrgCompositionStatus(orgId, compId, statusId) {
  const data = {
    org: orgId,
    comp: compId,
    status: statusId,
  };
  return refresh(async () => {
    const response = await fetch(orgCompositionInternalStatusUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}

export async function deleteOrgCompositionStatus(orgId, compId) {
  const data = {
    org: orgId,
    comp: compId,
  };
  return refresh(async () => {
    const response = await fetch(orgCompositionInternalStatusUrl, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
